// Maps Firebase Auth error codes to user-friendly text. Never surfaces the
// word "Firebase" or any other backend identifier to the UI.

const FRIENDLY: Record<string, string> = {
    'auth/invalid-credential': 'Wrong email or password.',
    'auth/wrong-password': 'Wrong email or password.',
    'auth/user-not-found': 'Wrong email or password.',
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/missing-email': 'Please enter an email address.',
    'auth/missing-password': 'Please enter a password.',
    'auth/weak-password': 'Password must be at least 6 characters.',
    'auth/email-already-in-use': 'An account with this email already exists. Try signing in instead.',
    'auth/too-many-requests': 'Too many attempts. Please wait a few minutes and try again.',
    'auth/network-request-failed': 'Network error. Check your connection and try again.',
    'auth/operation-not-allowed': "This sign-in method isn't available right now.",
    'auth/popup-closed-by-user': 'Sign-in cancelled.',
    'auth/invalid-phone-number': 'Please enter a valid phone number.',
    'auth/missing-phone-number': 'Please enter your phone number.',
    'auth/invalid-verification-code': 'Wrong verification code. Please try again.',
    'auth/code-expired': 'Verification code expired. Please request a new one.',
    'auth/captcha-check-failed': 'Verification failed. Please try again.',
    'auth/quota-exceeded': 'Service is busy right now. Please try again in a moment.',
};

export function friendlyAuthError(err: any): string {
    if (!err) return 'Something went wrong. Please try again.';
    const code = err.code as string | undefined;
    if (code && FRIENDLY[code]) return FRIENDLY[code];
    const msg = (err.message || '').toString();
    // Last resort: any leak of internal vendor names → swap for a generic.
    if (/firebase|firestore/i.test(msg)) return 'Something went wrong. Please try again.';
    return msg || 'Something went wrong. Please try again.';
}

export function isCredentialError(err: any): boolean {
    const code = err?.code;
    return code === 'auth/invalid-credential' || code === 'auth/wrong-password' || code === 'auth/user-not-found';
}

// Belt-and-braces filter for any string we're about to show to the user.
// Keeps backend identifiers out of the UI no matter where the message came from.
export function sanitizeMessage(msg: string | undefined | null, fallback = 'Something went wrong. Please try again.'): string {
    if (!msg) return fallback;
    if (/firebase|firestore|google\s*cloud/i.test(msg)) return fallback;
    return msg;
}
